export const ApiEndpoint = {
  // Auth
  Me: 'me',
  // Revenue
  RevenueMRR: 'api/v1/revenue/mrr',
  RevenueMRRIntervals: 'api/v1/revenue/mrr/intervals',
  RevenueCashFlow: 'api/v1/revenue/cash-flow',
  RevenueChurn: 'api/v1/revenue/churn',
  // Dashboard
  DashboardUsersTotals: 'api/v1/analytics/dashboard/users/totals',
  DashboardSubscribersTotals: 'api/v1/subscribers/totals',
  DashboardUsersMetrics: 'api/v1/analytics/dashboard/users/metrics',
  // Engagement
  EngagementMedia: 'api/v1/analytics/media',
  EngagementMediaTotals: 'api/v1/analytics/media/totals',
  EngagementEvents: 'api/v1/analytics/events',
  EngagementEventsCities: 'api/v1/analytics/events/cities',
  EngagementEventsTotals: 'api/v1/analytics/events/totals',
  EngagementCommunityPosts: 'api/v1/analytics/community/posts',
  EngagementCommunityChannels: 'api/v1/analytics/community/channels',
  EngagementCommunityTotals: 'api/v1/analytics/community/totals',
  EngagementChatChannels: 'api/v1/analytics/chat/channels',
  EngagementChatTotals: 'api/v1/analytics/chat/totals',
  EngagementSectionsSummary: 'api/v1/analytics/sections/summary',
  EngagementSectionsComparison: 'api/v1/analytics/sections/comparison',
  UsersMedia: 'api/v1/analytics/users/media',
  UsersEvents: 'api/v1/analytics/users/events',
  UsersForum: 'api/v1/analytics/users/forum',
  UsersChat: 'api/v1/analytics/users/chat',
  UsersTotals: 'api/v1/analytics/users/totals',
  // Subscribers (User Directory)
  Subscribers: 'api/v1/subscribers',
  SubscriberFilters: 'api/v1/subscribers/filters',
  SubscriberExport: 'api/v1/subscribers/export',
  SubscriberLevelCounts: 'api/v1/subscribers/level',
  // Reports
  Reports: 'api/v1/reports'
}
